import { render, staticRenderFns } from "./withdraw-money.vue?vue&type=template&id=44989078&scoped=true"
import script from "./withdraw-money.vue?vue&type=script&lang=js"
export * from "./withdraw-money.vue?vue&type=script&lang=js"
import style0 from "./withdraw-money.vue?vue&type=style&index=0&id=44989078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44989078",
  null
  
)

export default component.exports